module.exports = __webpack_public_path__ + "img/rub_fiatrail.340c0ee.png";